import * as React from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";

import { useFormState } from "app/lib/forms";


export default function NewVectorLayerForm({ onCancel, onComplete }) {
    const formState = useFormState();
    const onSubmit = event => {
        event.preventDefault();
        const values = formState.getValues();

        // TODO: actually create the layer
        console.log("Creating new layer", values);

        if (onComplete) {
            onComplete(values);
        }
    };
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup>
                <Label for="input-display-name">
                    Name:
                </Label>
                <Input
                    id="input-display-name"
                    type="text"
                    {...formState.getTextFieldProps("display-name")}
                />
            </FormGroup>
            <div className="text-end">
                <Button color="primary" type="submit">
                    Create layer
                </Button>
            </div>
        </Form>
    );
}
